import firebase from 'firebase';

 const firebaseConfig = {
  apiKey: "AIzaSyA8GtmNYyc3faTyRW0_IoDwf6WhSJ0ZQ4Y",
  authDomain: "miwatchfaces-b6312.firebaseapp.com",
  projectId: "miwatchfaces-b6312",
  storageBucket: "miwatchfaces-b6312.appspot.com",
  messagingSenderId: "822021029772",
  appId: "1:822021029772:web:06d434217180b5e07c20a9",
  measurementId: "G-BBX98ELDQF"
};
 

firebase.initializeApp(firebaseConfig);
var database = firebase.database();

export default database;
